import {Text, View, StyleSheet, Image} from '@react-pdf/renderer'
import {marcadoresMap} from '../util'
import * as turf from '@turf/turf'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Geometry} from '@turf/turf'

const styles = StyleSheet.create({
  table: {
    width: '100%',
    fontSize: 10,
    fontWeight: 'light',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    borderTop: '0px solid #EEE',
    paddingTop: 8,
    paddingBottom: 5,
  },
  rowErro: {
    display: 'flex',
    flexDirection: 'row',
    borderTop: '1px solid #EEE',
    paddingTop: 8,
    paddingBottom: 5,
    textAlign: 'center',
  },
  title: {
    marginTop: 15,
    marginBottom: 15,
    fontSize: 16,
    fontWeight: 'bold',
    borderBottomWidth: 1,
    borderBottomColor: '#2B8E57',
  },
  header: {
    borderTop: 'none',
    backgroundColor: '#dbdbdb',
    paddingHorizontal: 10,
  },
  bold: {
    fontWeight: 'black',
  },
  rowBorder: {
    borderColor: '#7a7a7a',
    borderTopWidth: 1,
  },
  rowDefault: {
    width: '40%',
  },
  rowDefault2: {
    width: '25%',
  },
  rowCenter: {
    width: '20%',
    textAlign: 'center',
  },
  decimal: {
    width: '20%',
    textAlign: 'center',
  },
  rowDetalhe: {
    backgroundColor: '#d0d0d0',
  },
  rowInfo: {
    backgroundColor: '#ff95956e',
  },
  currency: {
    width: '20%',
    textAlign: 'center',
  },
  row100px: {
    width: '100px',
  },
})
let totalArea = 0
let totaTestada = 0

export const Imoveis = ({imoveis}) => {
  // console.log('imoveis')
  // console.log(imoveis)
  let totalAreaCalculada = 0
  let count = -1
  if (imoveis) {
    return (
      <View style={styles.table}>
        <Text style={styles.title}>Imóveis</Text>
        <View style={[styles.row, styles.bold, styles.header]}>
          <Text style={{width: '8%'}}>x</Text>
          <Text style={styles.rowDefault}>Endereço</Text>
          <Text style={[styles.rowDefault2, styles.rowCenter]}>Nº Contribuinte</Text>
          <Text style={[styles.row100px, styles.rowCenter]}>Zona</Text>
          <Text style={[styles.rowDefault2, styles.rowCenter, styles.row100px]}>Área IPTU</Text>
          <Text style={[styles.rowDefault2, styles.rowCenter, styles.row100px]}>
            Área Calculada
          </Text>
          <Text style={[styles.rowDefault2, styles.rowCenter, styles.row100px]}> Testada</Text>
        </View>
        {imoveis.GetEmpreendimentoImovel.result.length === 0 && (
          <Text style={styles.rowErro}>Nenhum registro encontrado</Text>
        )}
        {imoveis.GetEmpreendimentoImovel.result.map((row, i) => {
          // console.log('row')
          // console.log(row)
          if (!row.terreno) return null
          totalArea += row.terreno.area_iptu || 0
          totaTestada += row.terreno.testada || 0

          let rowFormatDefault = [styles.row, styles.rowBorder]
          let rowFormatInfo = [styles.row, styles.rowInfo, styles.rowBorder]

          let showAlert = false
          if (
            row.terreno.operacao_urbana ||
            row.terreno.patrimonio_cultural ||
            row.terreno.melhoramento_viario ||
            row.terreno.contaminacao ||
            row.terreno.desapropriacao
          ) {
            showAlert = true
          }
          let area_calculada = row.terreno?.marcacao
            ? turf.area(row.terreno.marcacao as Geometry)
            : 0

          totalAreaCalculada = totalAreaCalculada + area_calculada
          count++
          return (
            <>
              <View key={i + 100} style={showAlert ? rowFormatInfo : rowFormatDefault} wrap={false}>
                <Text style={{width: '8%', textAlign: 'center'}}>{marcadoresMap[count]}</Text>
                <Text style={styles.rowDefault}>
                  {row.terreno.endereco},{row.terreno.numero}
                </Text>
                <Text style={[styles.rowDefault2, styles.rowCenter]}>
                  {row.terreno.numero_contribuinte}
                </Text>
                <Text style={[styles.rowDefault2, styles.rowCenter]}>{row.terreno.zoneamento}</Text>
                <Text style={[styles.rowDefault2, styles.rowCenter, styles.row100px]}>
                  {row.terreno.area_iptu}
                </Text>
                <Text style={[styles.rowDefault2, styles.rowCenter, styles.row100px]}>
                  {area_calculada.toFixed(0)}
                </Text>
                <Text style={[styles.rowDefault2, styles.rowCenter, styles.row100px]}>
                  {row.terreno.testada}
                </Text>
              </View>

              {row.terreno.operacao_urbana ? (
                <View key={i} style={[styles.row, styles.rowInfo]} wrap={false}>
                  <Text style={{width: '8%', textAlign: 'center'}}>
                    <Image
                      src={toAbsoluteUrl('/media/svgviewer-png-output.png')}
                      style={{width: 12, height: 12}}
                    ></Image>
                  </Text>
                  <Text>Operação Urbana: {row.terreno.operacao_urbana}</Text>
                </View>
              ) : (
                <></>
              )}
              {row.terreno.patrimonio_cultural ? (
                <View key={i} style={[styles.row, styles.rowInfo]} wrap={false}>
                  <Text style={{width: '8%', textAlign: 'center'}}>
                    <Image
                      src={toAbsoluteUrl('/media/svgviewer-png-output.png')}
                      style={{width: 12, height: 12}}
                    ></Image>
                  </Text>
                  <Text>Patrimônio Cultural: {row.terreno.patrimonio_cultural}</Text>
                </View>
              ) : (
                <></>
              )}
              {row.terreno.melhoramento_viario ? (
                <View key={i} style={[styles.row, styles.rowInfo]} wrap={false}>
                  <Text style={{width: '8%', textAlign: 'center'}}>
                    <Image
                      src={toAbsoluteUrl('/media/svgviewer-png-output.png')}
                      style={{width: 12, height: 12}}
                    ></Image>
                  </Text>
                  <Text>Melhoramento Viário: {row.terreno.melhoramento_viario}</Text>
                </View>
              ) : (
                <></>
              )}
              {row.terreno.contaminacao ? (
                <View key={i} style={[styles.row, styles.rowInfo]} wrap={false}>
                  <Text style={{width: '8%', textAlign: 'center'}}>
                    <Image
                      src={toAbsoluteUrl('/media/svgviewer-png-output.png')}
                      style={{width: 12, height: 12}}
                    ></Image>
                  </Text>
                  <Text>Contaminação: {row.terreno.contaminacao}</Text>
                </View>
              ) : (
                <></>
              )}
              {row.terreno.desapropriacao ? (
                <View key={i} style={[styles.row, styles.rowInfo]} wrap={false}>
                  <Text style={{width: '8%', textAlign: 'center'}}>
                    <Image
                      src={toAbsoluteUrl('/media/svgviewer-png-output.png')}
                      style={{width: 12, height: 12}}
                    ></Image>
                  </Text>
                  <Text style={{width: '92%'}}>Desapropriação: {row.terreno.desapropriacao}</Text>
                </View>
              ) : (
                <></>
              )}
            </>
          )
        })}
        <View key={99999} style={[styles.row, styles.rowDetalhe]} wrap={false}>
          <Text style={{width: '8%'}}></Text>
          <Text style={styles.rowDefault2}></Text>
          <Text style={styles.rowDefault2}></Text>
          <Text style={[styles.rowDefault2, styles.rowCenter]}>Total</Text>
          <Text style={[styles.rowDefault2, styles.rowCenter, styles.row100px]}>{totalArea}</Text>
          <Text style={[styles.rowDefault2, styles.rowCenter, styles.row100px]}>
            {totalAreaCalculada.toFixed(0)}
          </Text>
          <Text style={[styles.rowDefault2, styles.rowCenter, styles.row100px]}>
            {totaTestada.toFixed(2)}
          </Text>
        </View>
      </View>
    )
  }
}
